export default function bookingOptionsController(
    $scope,
    $location,
    $q,
    Basket,
    Bookings,
    BookingPeriods,
    Resources,
    CheckoutErrors,
    moment
) {
    $scope.totalPrice = 0;
    $scope.bookingError = { error: false };
    $scope.bookingPeriods = null;

    // const location = Basket.getBookingLocation();
    // $scope.location = location;

    // Validate if there is a bookingId in basket
    const bookingId = Basket.getBookingId();

    if (!bookingId) {
        $scope.bookingError = CheckoutErrors.getBookingError({
            error: true,
            type: "no-booking-id-in-basket",
        });
        return;
    }

    // Verify booking
    Bookings.verify(bookingId)
        .then(() => {
            // Check if there is a reserved payment for the current booking
            // - If found go to confirmations page
            Bookings.get(bookingId).then((booking) => {
                const reservedPayment = booking.payments.find(
                    (x) => x.statusCode == 202
                );

                if (reservedPayment) {
                    $location
                        .path(`/checkout/payment-complete/`)
                        .search({ paymentid: reservedPayment.paymentID });
                    return;
                }
            });

            // Validate booking periods
            Bookings.getBookingPeriods(bookingId).then(
                (res) => {
                    let bookingPeriods = res;

                    if (!bookingPeriods.length) {
                        $scope.bookingError = CheckoutErrors.getBookingError({
                            error: true,
                            type: "booking-expired",
                        });
                        return false;
                    }

                    bookingPeriods = bookingPeriods.filter(
                        (bp) => bp.status == "New"
                    );

                    const promises = bookingPeriods.map((bp) => {
                        return getBpEntries(bp);
                    });

                    $q.all(promises).then((res) => {
                        const resourceEntries = res;

                        bookingPeriods.forEach((bp, index) => {
                            bp.bookingPeriodEntries = resourceEntries[index];
                        });

                        $scope.bookingPeriods = bookingPeriods;
                        $scope.resourceEntries = resourceEntries;
                    });
                },
                (err) => {
                    console.warn(err);
                    $scope.bookingError = CheckoutErrors.getBookingError({
                        error: true,
                        type: "booking-not-found",
                    });
                }
            );
        })
        .catch(() => {
            $scope.bookingError = CheckoutErrors.getBookingError({
                error: true,
                type: "booking-invalid-prices",
            });

            return;
        });

    $scope.changeBookingPeriods = () => {
        const lastSearchPeriodsUrl = Basket.getSearchPeriodsUrl();
        const path = lastSearchPeriodsUrl ? lastSearchPeriodsUrl : "/";
        $location.url(path);
    };

    const getBpEntries = (bp) => {
        /**
         * Get ResourceEntries which belongs to the bookingPeriod
         */
        const rePromise = Resources.getEntries(bp.resourceId, bp.start, bp.end);
        const bpRePromise = BookingPeriods.getEntries(bp.id);

        return $q
            .all({
                resourceEntries: rePromise,
                bpEntries: bpRePromise,
            })
            .then((res) => {
                /**
                 * add prop "amount" to resourceEntries (morph)
                 */

                return res.resourceEntries
                    .filter((re) => {
                        // Filter services
                        return moment(bp.start)
                            .subtract(
                                re.service.activeDaysBeforeBooking,
                                "days"
                            )
                            .isSameOrAfter();
                    })
                    .map((re) => {
                        let bpeId = null;

                        // search matches in bpEntries
                        const bpEntries = res.bpEntries.filter(
                            (bpRe) => bpRe.resourceEntryId == re.id
                        );

                        bpEntries.map((bp) => {
                            bpeId = bp.id;
                        });

                        // iterate bpEntries to get amount
                        const amount = bpEntries.reduce((acc, obj) => {
                            return acc + obj.amount;
                        }, 0);

                        const bpe = {
                            _id: bpeId,
                            _amountOnLoad: amount, // morph
                            _minAmount: re.minAmount, // morph
                            _maxAmount: re.maxAmount, // morph
                            _isPreselected: re.isPreselected, // morph
                            _isRequired: re.isRequired, // morph
                            resourceEntryId: re.id,
                            name: re.name,
                            price: re.price,
                            amount:
                                amount < re.minAmount ? re.minAmount : amount, // ensure minAmount
                        };

                        return bpe;
                    });
            });

        // const promises = bookingPeriods.map((bp) => {
        //     return BookingPeriods.getEntries(bp.id);
        // });
    };

    $scope.nextBookingStep = () => {
        // SAVE ENTRIES !!! NOW

        /***
         *
         * // TO DO ::: LOW ::: Should this be changed to Bookings.update(booking) ???
         * BookingPeriods.addEntry()
         * for each booking period
         */

        const promises = $scope.bookingPeriods.map((bp) => {
            const bpePromises = bp.bookingPeriodEntries.map((bpe) => {
                const amountOnLoad = bpe._amountOnLoad;
                const bpeId = bpe._id;

                delete bpe._amountOnLoad;
                delete bpe._minAmount;
                delete bpe._maxAmount;
                delete bpe._id;
                delete bpe._isPreselected;
                delete bpe._isRequired;

                // DID THE USER CHANGE ANYTHING ?
                return bpe.amount !== amountOnLoad
                    ? bpeId
                        ? BookingPeriods.updateEntry(bp.id, bpeId, bpe)
                        : BookingPeriods.addEntry(bp.id, bpe)
                    : null;
            });

            return $q.all(bpePromises);
        });

        // add entries (promises)
        $q.all(promises).then(() => {
            $location.path("/checkout/bookinginfo");
        });
    };
}
